// extracted by mini-css-extract-plugin
export default {"slotHighlighted":"RD6o_5"};